import { render, staticRenderFns } from "./reportFlagModal.vue?vue&type=template&id=2cae2982&scoped=true"
import script from "./reportFlagModal.vue?vue&type=script&lang=js"
export * from "./reportFlagModal.vue?vue&type=script&lang=js"
import style0 from "./reportFlagModal.vue?vue&type=style&index=0&id=2cae2982&prod&lang=scss"
import style1 from "./reportFlagModal.vue?vue&type=style&index=1&id=2cae2982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cae2982",
  null
  
)

export default component.exports